import { apiClient } from './apiClient';

/**
 * User Profile Service - Manages users (consolidated from user-profiles)
 * Now uses the /users endpoint for all operations
 */
export class UserProfileService {
    constructor() {
        this.baseUrl = '/users';  // Changed from /user-profiles
    }

    /**
     * Get all users with optional role filter
     * @param {string} role - Optional role filter
     * @returns {Promise<Array>} Array of users
     */
    async getAllUserProfiles(role = null) {
        try {
            const url = role ? `${this.baseUrl}?role=${role}` : this.baseUrl;
            const response = await apiClient.get(url);
            return response;
        } catch (error) {
            console.error('Error fetching users:', error);
            throw error;
        }
    }

    /**
     * Get users filtered by role
     * @param {string} role - Role to filter by
     * @returns {Promise<Array>} Array of users with the specified role
     */
    async getUserProfilesByRole(role) {
        return this.getAllUserProfiles(role);
    }

    /**
     * Get user by ID
     * @param {string} id - User ID
     * @returns {Promise<Object>} User data
     */
    async getUserProfileById(id) {
        try {
            const response = await apiClient.get(`${this.baseUrl}/${id}`);
            return response;
        } catch (error) {
            console.error('Error fetching user:', error);
            throw error;
        }
    }

    /**
     * Create a new user
     * @param {Object} userData - User data to create
     * @returns {Promise<Object>} Created user
     */
    async createUserProfile(userData) {
        try {
            const response = await apiClient.post(this.baseUrl, userData);
            return response;
        } catch (error) {
            console.error('Error creating user:', error);
            throw error;
        }
    }

    /**
     * Update a user
     * @param {string} id - User ID
     * @param {Object} userData - Updated user data
     * @returns {Promise<Object>} Updated user
     */
    async updateUserProfile(id, userData) {
        try {
            const response = await apiClient.put(`${this.baseUrl}/${id}`, userData);
            return response;
        } catch (error) {
            console.error('Error updating user:', error);
            throw error;
        }
    }

    /**
     * Delete a user
     * @param {string} id - User ID
     * @returns {Promise<Object>} Deletion result
     */
    async deleteUserProfile(id) {
        try {
            const response = await apiClient.delete(`${this.baseUrl}/${id}`);
            return response;
        } catch (error) {
            console.error('Error deleting user:', error);
            throw error;
        }
    }
}

export const userProfileService = new UserProfileService();